import axios from "axios";
import db from "@/components/Firebase.js";

const state = {
  restaurants: [],
  restaurantsFiltered: [],
  restaurantsSelected: [],
  pollID: "",
  searchTerm: "restaurants",
  showChecklist: false
};

const getters = {
  allRestaurants: state => state.restaurants,
  filteredRestaurants: state => state.restaurantsFiltered,
  selectedRestaurants: state => state.restaurantsSelected,
  getPollID: state => state.pollID,
  showChecklist: state => state.showChecklist
};

const actions = {
  async fetchRestaurants({ commit, dispatch }, filter) {
    // console.log(filter[3]);
    // console.log(filter[2]);
    // console.log(state.restaurantsSelected);
    let newRestaurants = [];

    axios
      .get(
        `${"https://cors-anywhere.herokuapp.com/"}https://api.yelp.com/v3/businesses/search?term=` +
          state.searchTerm +
          `&latitude=` +
          filter[3] +
          `&longitude=` +
          filter[4] +
          `&open_now=true`,
        {
          headers: {
            Authorization: `Bearer 0cHij1ElEWRzD-K5fpPkd807azDkPzUj2RyJj_S7FBbL5ULTPESioaRMeTBYXwpS_kL-Bd3FcyhnpS3Eu6aikbdDhJvOIiTcEMkysfh3JZ7FR-fSQ_T1Ty3wzbTEXHYx`
          }
        }
      )
      .then(res => {
        for (var restaurant of res.data.businesses) {
          newRestaurants = [
            ...newRestaurants,
            {
              id: restaurant.id,
              name: restaurant.name,
              image_url: restaurant.image_url,
              price: restaurant.price,
              rating: restaurant.rating,
              distance: restaurant.distance * 0.000621371,
              display: true,
              votes: 0
            }
          ];
        }
        commit("setRestaurants", newRestaurants);
        dispatch("filterRestaurants", filter);
        commit("setShowChecklist", true);
        //commit("setRestaurantsFiltered", newRestaurants);
      })
      .catch(err => {
        alert(err);
      });
  },
  filterRestaurants({ commit }, filters) {
    if (filters[0] != null || filters[1] != null || filters[2] != null) {
      if (filters[0] != null && filters[1] != null && filters[2] != null) {
        commit(
          "setRestaurantsFiltered",
          state.restaurants.filter(
            restaurant =>
              restaurant.price == filters[1] &&
              restaurant.rating >= filters[0] &&
              restaurant.distance <= filters[2]
          )
        );
      } else {
        if (filters[0] != null && filters[1] == null && filters[2] == null) {
          commit(
            "setRestaurantsFiltered",
            state.restaurants.filter(
              restaurant => restaurant.rating >= filters[0]
            )
          );
        } else {
          if (filters[0] == null && filters[1] != null && filters[2] == null) {
            commit(
              "setRestaurantsFiltered",
              state.restaurants.filter(
                restaurant => restaurant.price == filters[1]
              )
            );
          } else {
            if (
              filters[0] == null &&
              filters[1] == null &&
              filters[2] != null
            ) {
              commit(
                "setRestaurantsFiltered",
                state.restaurants.filter(
                  restaurant => restaurant.distance <= filters[2]
                )
              );
            } else {
              if (
                filters[0] != null &&
                filters[1] != null &&
                filters[2] == null
              ) {
                commit(
                  "setRestaurantsFiltered",
                  state.restaurants.filter(
                    restaurant =>
                      restaurant.price == filters[1] &&
                      restaurant.rating >= filters[0]
                  )
                );
              } else {
                if (
                  filters[0] != null &&
                  filters[1] == null &&
                  filters[2] != null
                ) {
                  commit(
                    "setRestaurantsFiltered",
                    state.restaurants.filter(
                      restaurant =>
                        restaurant.rating >= filters[0] &&
                        restaurant.distance <= filters[2]
                    )
                  );
                } else {
                  if (
                    filters[0] == null &&
                    filters[1] != null &&
                    filters[2] != null
                  ) {
                    commit(
                      "setRestaurantsFiltered",
                      state.restaurants.filter(
                        restaurant =>
                          restaurant.price == filters[1] &&
                          restaurant.distance <= filters[2]
                      )
                    );
                  }
                }
              }
            }
          }
        }
      }
    } else {
      commit("setRestaurantsFiltered", state.restaurants);
    }
  },
  sendPollData({ commit }, selected) {
    //console.log(selected);

    let newPollRef = db.collection("polls").doc();
    commit("setPollID", newPollRef.id);

    let pollBatch = db.batch();
    pollBatch.set(newPollRef, { [selected[0].id]: "bar" });

    for (let i = 0; i < selected.length; i++) {
      pollBatch.update(newPollRef, { [selected[i].id]: selected[i] });
    }
    pollBatch.update(newPollRef, { totalVotes: 0 });
    pollBatch.commit().catch(function(error) {
      alert(err);
      //console.error("Error writing document: ", error);
    });
  }
};

const mutations = {
  setRestaurants: (state, restaurants) => (state.restaurants = restaurants),
  setRestaurantsFiltered: (state, restaurants) =>
    (state.restaurantsFiltered = restaurants),
  setRestaurantsSelected: (state, restaurants) =>
    (state.restaurants = restaurants),
  setPollID: (state, pollID) => (state.pollID = pollID),
  setSearchTerm: (state, searchTerm) => (state.searchTerm = searchTerm),
  setShowChecklist: (state, showChecklist) =>
    (state.showChecklist = showChecklist)
};

export default {
  state,
  getters,
  actions,
  mutations
};
